import React from "react";
import { Form } from "react-final-form";
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { TextField } from "@syos-music/form";
import { Dialog } from "@syos-music/common";

import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import IntlTextField from "components/form/IntlTextField";

const MUTATION = gql`
  mutation ($referralReward: ReferralRewardInput!) {
    CreateReferralReward(referralReward: $referralReward) {
      referralReward {
        id
      }
    }
  }
`;

export default function CreateReferralRewardDialog({ onCreate, children }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [createReferralReward] = useMutation(MUTATION);

  return (
    <>
      {children({ open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={async (values) =>
            createReferralReward({
              variables: {
                referralReward: {
                  ...values,
                  points: parseInt(values.points),
                },
              },
            })
              .then(({ data }) =>
                onCreate?.(data.CreateReferralReward.referralReward)
              )
              .then(close)
              .catch(() => true)
          }
          initialValues={{}}
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <Dialog.Title color="primary">
                Créer une récompense de parrainage
              </Dialog.Title>

              <Dialog.Content>
                <Grid container>
                  <Grid item xs={12}>
                    <IntlTextField name="label" required label="Label" />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      name="points"
                      required
                      type="number"
                      label="Points"
                    />
                  </Grid>
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <LoadingButton type="submit" loading={submitting}>
                  Valider
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}
